<template>
  <div class="SliderText">

    <div class="SliderText-header"
      v-if="content.supertitle || content.title || content.smalltitle || content.subtitle || content.subtitle2">

      <p class="SliderText-supertitle t-caps"
        v-if="content.superTitle"
        v-html="content.superTitle">
      </p>

      <p class="SliderText-title t-headingMd"
        v-if="content.title"
        v-html="content.title">
      </p>

      <p class="SliderText-smalltitle t-headingSm"
        v-if="content.smalltitle"
        v-html="content.smalltitle">
      </p>

      <p class="SliderText-subtitle t-caps"
        v-if="content.subtitle"
        v-html="content.subtitle">
      </p>

      <p class="SliderText-subtitle SliderText-subtitle2 t-caps"
        v-if="content.subtitle2"
        v-html="content.subtitle2">
      </p>

      <p class="SliderText-subtitle SliderText-subtitle3 t-caps"
        v-if="content.subtitle3"
        v-html="content.subtitle3">
      </p>

    </div>

    <div class="SliderText-content"
      v-if="content.text">

      <pre class="t-headingSm"
        v-if="content.text"
        v-html="content.text">
      </pre>

    </div>

    <ol class="SliderText-list t-list"
      v-if="content.list">

      <li class="t-listItem"
        v-for="item in content.list">

        <p class="t-caps"
          v-if="item.supertitle"
          v-html="item.supertitle">
        </p>

        <p class="SliderText-listItemTitle t-headingSm"
          v-if="item.title"
          v-html="item.title">
        </p>

      </li>

    </ol>

    <p class="SliderText-footer t-small"
      v-if="content.footer"
      v-html="content.footer">
    </p>

  </div>
</template>

<script>
export default {
  name: 'SliderText',

  props: {
    content: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.SliderText {
  text-align: center;
}

.SliderText-header {
  margin: 0 auto;
  max-width: 540px;
}

.SliderText-title,
.SliderText-smalltitle {
  color: var(--color-5);
}

.SliderText-supertitle + .SliderText-title {
  margin-top: 1rem;
}

.SliderText-title + .SliderText-smalltitle,
.SliderText-title + .SliderText-subtitle,
.SliderText-smalltitle + .SliderText-subtitle {
  margin-top: 1rem;
}

.SliderText-header + .SliderText-content,
.SliderText-header + .SliderText-list,
.SliderText-content + .SliderText-list {
  margin-top: 2rem;
}

.SliderText-footer {
  margin-top: 2rem;
}

.SliderText-listItemTitle {
  color: var(--color-5);
}
</style>



// WEBPACK FOOTER //
// Text.vue?14cb390b